export type NewArFormValue = {
  financialsStartDate: string | null
  financialsEndDate: string | null
}
